
import gql from 'graphql-tag';
import InterchangeEventDetail from '@/components/InterchangeEventDetail/index.vue';
import Vue from 'vue';

export default Vue.extend({
	name: 'InterchangeEventDetailDialog',
	components: {
		InterchangeEventDetail
	},
	props: {
		visible: { type: Boolean, default: false },
		actionRef: { type: String, default: '' },
		initialEventRef: { type: String, default: '' },
		/** Timeline row (`risolto_virtual_action_and_note_v4` shape); used for title only. */
		item: { type: Object, default: null }
	},
	data() {
		return {
			loading: false,
			actionInterchanges: [] as Array<Record<string, unknown>>,
			interchangeCount: 0,
			eventCount: 0
		};
	},
	computed: {
		dialogVisible: {
			get(): boolean {
				return this.visible;
			},
			set(v: boolean) {
				this.$emit('update:visible', v);
			}
		}
	},
	watch: {
		visible(v: boolean) {
			if (v) {
				this.fetchInterchangeEventDetails();
			}
		},
		actionRef() {
			if (this.visible) {
				this.fetchInterchangeEventDetails();
			}
		}
	},
	methods: {
		countDocumentEvents(interchanges: Array<{ interchange_by_reference?: { interchange_event?: unknown[] } }>) {
			let n = 0;
			for (const item of interchanges) {
				const ev = item.interchange_by_reference?.interchange_event;
				n += Array.isArray(ev) ? ev.length : 0;
			}
			return n;
		},
		async fetchInterchangeEventDetails() {
			if (!this.actionRef) {
				this.actionInterchanges = [];
				this.interchangeCount = 0;
				this.eventCount = 0;
				return;
			}
			this.loading = true;
			this.actionInterchanges = [];
			this.interchangeCount = 0;
			this.eventCount = 0;
			try {
				const qry = gql`
query GetInterchangeEventDetails($actionRef: uuid!) {
  risolto_action(where: { reference: { _eq: $actionRef } }) {
    action_interchanges {
      interchange_by_reference {
        reference
        channel
        interchange_event(order_by: { created_at: desc }) {
          reference
          interchange
          created_at
          event_type
          event_subtype
          raw_data
          failure
        }
      }
    }
  }
}
				`;
				const result = await this.$apollo.query({
					query: qry,
					variables: { actionRef: this.actionRef },
					fetchPolicy: 'no-cache'
				});
				const action = result?.data?.risolto_action?.[0];
				const interchanges = action?.action_interchanges || [];
				this.actionInterchanges = interchanges;
				this.interchangeCount = interchanges.length;
				this.eventCount = this.countDocumentEvents(interchanges);
			} finally {
				this.loading = false;
			}
		},
		handleClose() {
			this.$emit('update:visible', false);
		}
	}
});
